import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCategoryResult = { item: '_category' };
var _bulkCreateCategoriesRequest = { categories: '_category' };
var _bulkCreateCategoriesResponse = { results: '_bulkCategoryResult' };
var _bulkDeleteCategoryRequest = {};
var _bulkDeleteCategoryResponse = {};
var _bulkUpdateCategoriesRequest = { categories: '_maskedCategory' };
var _bulkUpdateCategoriesResponse = { results: '_bulkCategoryResult' };
var _category = {
    updatedDate: 'google.protobuf.Timestamp',
    coverImage: '_image',
};
var _createCategoryRequest = { category: '_category' };
var _createCategoryResponse = { category: '_category' };
var _deleteCategoryRequest = {};
var _deleteCategoryResponse = {};
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getCategoriesCountByLanguageRequest = {};
var _getCategoriesCountByLanguageResponse = {};
var _getCategoryBySlugRequest = {};
var _getCategoryBySlugResponse = { category: '_category' };
var _getCategoryRequest = {};
var _getCategoryResponse = { category: '_category' };
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _listCategoriesRequest = {};
var _listCategoriesResponse = { categories: '_category' };
var _maskedCategory = {
    fieldMask: 'google.protobuf.FieldMask',
    category: '_category',
};
var _queryCategoriesRequest = {};
var _queryCategoriesResponse = { categories: '_category' };
var _updateCategoryRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    category: '_category',
};
var _updateCategoryResponse = { category: '_category' };
function resolveComWixpressNpmCommunitiesPlatformizedBlogV3CategoryServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/bulk/category',
                destPath: '/v3/bulk/category',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/bulk/categories',
                destPath: '/v3/bulk/categories',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/blog/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/category-service-api-proxy',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a category. */
export function createCategory(payload) {
    var _a = serializer(_createCategoryRequest, { _category: _category, _focalPoint: _focalPoint, _image: _image }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCategoryResponse, {
        _category: _category,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __createCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.category',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.CategoryService.CreateCategory',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3CategoryServiceUrl({ protoPath: '/v3/categories', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCategory.fromReq = fromReq;
    __createCategory.__isAmbassador = true;
    return __createCategory;
}
/** Creates multiple categories. */
export function bulkCreateCategories(payload) {
    var _a = serializer(_bulkCreateCategoriesRequest, { _category: _category, _focalPoint: _focalPoint, _image: _image }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateCategoriesResponse, {
        _bulkCategoryResult: _bulkCategoryResult,
        _category: _category,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __bulkCreateCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.category',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.CategoryService.BulkCreateCategories',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3CategoryServiceUrl({ protoPath: '/v3/bulk/categories/create', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateCategories.fromReq = fromReq;
    __bulkCreateCategories.__isAmbassador = true;
    return __bulkCreateCategories;
}
/** Updates multiple categories. */
export function bulkUpdateCategories(payload) {
    var _a = serializer(_bulkUpdateCategoriesRequest, { _category: _category, _focalPoint: _focalPoint, _image: _image, _maskedCategory: _maskedCategory }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateCategoriesResponse, {
        _bulkCategoryResult: _bulkCategoryResult,
        _category: _category,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __bulkUpdateCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.category',
            method: 'PATCH',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.CategoryService.BulkUpdateCategories',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3CategoryServiceUrl({ protoPath: '/v3/bulk/categories/update', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateCategories.fromReq = fromReq;
    __bulkUpdateCategories.__isAmbassador = true;
    return __bulkUpdateCategories;
}
/** Updates a category. */
export function updateCategory(payload) {
    var _a = serializer(_updateCategoryRequest, { _category: _category, _focalPoint: _focalPoint, _image: _image }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCategoryResponse, {
        _category: _category,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __updateCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.category',
            method: 'PATCH',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.CategoryService.UpdateCategory',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3CategoryServiceUrl({
                protoPath: '/v3/categories/{category.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCategory.fromReq = fromReq;
    __updateCategory.__isAmbassador = true;
    return __updateCategory;
}
/** Retrieves a count of categories for every site language. */
export function getCategoriesCountByLanguage(payload) {
    var _a = serializer(_getCategoriesCountByLanguageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCategoriesCountByLanguageResponse, {}).fromJSON;
    function __getCategoriesCountByLanguage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.category',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.CategoryService.GetCategoriesCountByLanguage',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3CategoryServiceUrl({
                protoPath: '/v3/categories/count-by-language',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCategoriesCountByLanguage.fromReq = fromReq;
    __getCategoriesCountByLanguage.__isAmbassador = true;
    return __getCategoriesCountByLanguage;
}
/** Gets a category with the specified ID. */
export function getCategory(payload) {
    var _a = serializer(_getCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCategoryResponse, {
        _category: _category,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __getCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.category',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.CategoryService.GetCategory',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3CategoryServiceUrl({ protoPath: '/v3/categories/{categoryId}', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCategory.fromReq = fromReq;
    __getCategory.__isAmbassador = true;
    return __getCategory;
}
/**
 * Gets a category with the specified slug.
 *
 * The slug is at the end of the URL of a specific category.
 * For example, if a category's URL is `https://example.com/blog/categories/famous-cats`, the slug is `famous-cats`.
 * The slug is a case-sensitive string that is derived from the category's label, unless specified otherwise.
 */
export function getCategoryBySlug(payload) {
    var _a = serializer(_getCategoryBySlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCategoryBySlugResponse, {
        _category: _category,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __getCategoryBySlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.category',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.CategoryService.GetCategoryBySlug',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3CategoryServiceUrl({ protoPath: '/v3/categories/slugs/{slug}', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCategoryBySlug.fromReq = fromReq;
    __getCategoryBySlug.__isAmbassador = true;
    return __getCategoryBySlug;
}
/**
 * Retrieves a list of up to 100 categories per request.
 *
 * If you pass a language filter to the method, it returns a list of up to 100 categories in the requested language.
 *
 * The categoies are displayed in order of their `displayPosition`, starting with `0`. The `displayPosition` is the position in which the categories
 * are displayed in the Category Menu page. By default, categories get added to the bottom of the Category Menu page with a `displayPosition` of `-1`.
 *
 * List Categories runs with these defaults, which you can override:
 * - `paging.limit` is `50`.
 * - `paging.offset` is `0`.
 *
 * List Categories is sorted by `displayPosition` in descending order. This cannot be overridden.
 */
export function listCategories(payload) {
    var _a = serializer(_listCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCategoriesResponse, {
        _category: _category,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __listCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.category',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.CategoryService.ListCategories',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3CategoryServiceUrl({ protoPath: '/v3/categories', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCategories.fromReq = fromReq;
    __listCategories.__isAmbassador = true;
    return __listCategories;
}
/**
 * Retrieves a list of up to 100 categories, given the provided paging, filtering, and sorting.
 * Query Categories runs with these defaults, which you can override.
 * - `displayPosition` is sorted in `DESC` order.
 * - `paging.limit` is `50`.
 * - `paging.offset` is `0`.
 *
 * For field support for filters and sorting, see
 * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/category/filter-and-sort).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging), and
 * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryCategories(payload) {
    var _a = serializer(_queryCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCategoriesResponse, {
        _category: _category,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __queryCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.category',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.CategoryService.QueryCategories',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3CategoryServiceUrl({ protoPath: '/v3/categories/query', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCategories.fromReq = fromReq;
    __queryCategories.__isAmbassador = true;
    return __queryCategories;
}
/** Bulk delete for categories */
export function bulkDeleteCategory(payload) {
    var _a = serializer(_bulkDeleteCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteCategoryResponse, {}).fromJSON;
    function __bulkDeleteCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.category',
            method: 'DELETE',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.CategoryService.BulkDeleteCategory',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3CategoryServiceUrl({ protoPath: '/v3/bulk/category', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteCategory.fromReq = fromReq;
    __bulkDeleteCategory.__isAmbassador = true;
    return __bulkDeleteCategory;
}
/** Deletes a category. */
export function deleteCategory(payload) {
    var _a = serializer(_deleteCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCategoryResponse, {}).fromJSON;
    function __deleteCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.category',
            method: 'DELETE',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.CategoryService.DeleteCategory',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3CategoryServiceUrl({ protoPath: '/v3/categories/{categoryId}', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCategory.fromReq = fromReq;
    __deleteCategory.__isAmbassador = true;
    return __deleteCategory;
}
//# sourceMappingURL=http.impl.js.map